import styles from 'components/Categories/styles.scss';
import { Category } from 'components/Categories';
import { Section } from 'components/Shared/Layout';
import { CategoryLinks } from 'components/Shared/CategoryLinks';

interface OwnProps {
  categories: Category[];
  showAllCategoriesText: string;
}

export default ({ categories, showAllCategoriesText }: OwnProps) => (
  <Section className={styles.sectionSubcategories} shadow>
    <div className={styles.categories}>
      {categories.map(category => (
        <CategoryLinks
          hideLinksInMobile
          className={styles.sectionSubcategory}
          title={category.title}
          key={category.id}
          image={category.image}
          links={category.subCategories}
          showAllCategories={category.showAllCategories}
          showAllCategoriesText={showAllCategoriesText}
          categoryUrl={category.url}
          numberOfCategories={category.subCategoriesCount}
        />
      ))}
    </div>
  </Section>
);
